<div [class.unauthorized-message--modal]="isModal" *ngIf="isModal ? visible : true">
    <div class="unauthorized-message__container">
        <img class="unauthorized-message__image" src="/assets/icons/window-key.svg" alt="Icon" />
        <h1 class="unauthorized-message__title">Access Restricted</h1>
        <div>
            <p class="unauthorized-message__text" [innerHTML]="sanitizedContent"></p>
            <button
                class="unauthorized-message__button"
                (click)="handleButtonClick()"
                *ngIf="buttonLabel?.length"
            >
                <img src="/assets/icons/arrow-left-white.svg" alt="Icon" />
                {{ buttonLabel }}
            </button>
        </div>
    </div>
</div>
